import {
  ExamEventExamineeResultCertificateType,
  useGetPublicCertificateByExamEventExamineeIdQuery,
} from '@certificate/graphql';
import { useEffect } from 'react';

import { CertificateNavigatorError, CertificateNavigatorLoading } from '../../components';

interface PublicCertificateNavigatorProps {
  examEventExamineeId: string;
  type: 'social-media' | 'unofficial';
}

const examEventExamineeResultCertificateTypeMap = {
  'social-media': ExamEventExamineeResultCertificateType.SocialMedia,
  unofficial: ExamEventExamineeResultCertificateType.Unofficial,
};

export default function PublicCertificateNavigator(
  props: Readonly<PublicCertificateNavigatorProps>,
) {
  const { examEventExamineeId, type } = props;

  const {
    data,
    error,
    loading: isLoading,
  } = useGetPublicCertificateByExamEventExamineeIdQuery({
    variables: {
      input: {
        examEventExamineeId,
        type: examEventExamineeResultCertificateTypeMap[type],
      },
    },
  });

  useEffect(() => {
    const url = data?.certGetPublicCertificateByExamEventExamineeId?.publicCertificateUrl;
    if (url) {
      window.location.href = url;
    }
  }, [data]);

  if (isLoading) {
    return <CertificateNavigatorLoading />;
  }

  if (error || !data?.certGetPublicCertificateByExamEventExamineeId?.publicCertificateUrl) {
    return <CertificateNavigatorError />;
  }

  return null;
}
